import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { Event } from "../../types/Types";

type UpdateEventDto = Partial<Event>;

/** POST /Event/Create returns this shape (camelCase from System.Text.Json). */
export type CreateEventResponse = {
  id: number;
  eventCode: string;
};

export type SaveEventResult = CreateEventResponse | Event | undefined;

function normalizeCreateEventResponse(
  data: unknown
): CreateEventResponse | undefined {
  if (data && typeof data === "object") {
    const o = data as Record<string, unknown>;
    const id =
      typeof o.id === "number"
        ? o.id
        : typeof o.Id === "number"
          ? o.Id
          : undefined;
    const eventCode =
      typeof o.eventCode === "string"
        ? o.eventCode
        : typeof o.EventCode === "string"
          ? o.EventCode
          : undefined;
    if (id !== undefined && eventCode !== undefined) {
      return { id, eventCode };
    }
  }
  return undefined;
}

export const useSaveEvent = (
  options?: UseMutationOptions<
    SaveEventResult,
    unknown,
    Event | UpdateEventDto,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: Partial<Event>) => {
      if (data.id) {
        return axiosInstance
          .put(getAPIURL(`/Event/Update`), data)
          .then((res) => res.data as SaveEventResult);
      } else {
        return axiosInstance
          .post(getAPIURL("/Event/Create"), data)
          .then((res) => normalizeCreateEventResponse(res.data));
      }
    },
  });
};
